module.exports = __webpack_public_path__ + "img/logo-white.65244965.png";